export const SAILING_BOAT_STATUSES = Object.freeze(['active', 'maintenance', 'retired']);

export function normalizeSailingBoatStatus(value = 'active') {
  const status = String(value || '').trim().toLowerCase();
  return SAILING_BOAT_STATUSES.includes(status) ? status : 'active';
}

export function safeSailingBoatLabel(boat = {}, { showName = true } = {}) {
  if (!boat) return '';
  if (!showName) return 'Club boat';
  const name = String(boat.name || '').trim();
  const type = String(boat.type || boat.className || '').trim();
  return [name || 'Club boat', type && type !== name ? type : ''].filter(Boolean).join(' · ');
}

export function sanitizeSailingBoatForMooringView(boat = {}, { showName = true } = {}) {
  if (!boat) return null;
  return {
    label: safeSailingBoatLabel(boat, { showName }),
    status: normalizeSailingBoatStatus(boat.status),
    type: String(boat.type || boat.className || '').trim(),
    length: Number.isFinite(Number(boat.length)) ? Number(boat.length) : null,
    beam: Number.isFinite(Number(boat.beam)) ? Number(boat.beam) : null,
    draft: Number.isFinite(Number(boat.draft)) ? Number(boat.draft) : null,
  };
}

export function sailingBoatFitsSpace(boat = {}, space = {}) {
  const reasons = [];
  const checks = [
    ['length', 'maxLength', 'Length'],
    ['beam', 'maxBeam', 'Beam'],
    ['draft', 'maxDraft', 'Draft'],
  ];
  checks.forEach(([boatKey, spaceKey, label]) => {
    const boatValue = Number(boat?.[boatKey]);
    const spaceValue = Number(space?.[spaceKey]);
    if (Number.isFinite(boatValue) && Number.isFinite(spaceValue) && spaceValue > 0 && boatValue > spaceValue) {
      reasons.push(`${label} ${boatValue}m exceeds ${spaceValue}m limit.`);
    }
  });
  return { fits: reasons.length === 0, reasons };
}

export function bookingWindowsOverlap(left = {}, right = {}) {
  if (!left?.date || !right?.date) return false;
  const leftDate = typeof left.date === 'string' ? left.date : left.date?.toDate?.()?.toISOString?.().slice(0, 10);
  const rightDate = typeof right.date === 'string' ? right.date : right.date?.toDate?.()?.toISOString?.().slice(0, 10);
  if (leftDate && rightDate && leftDate !== rightDate) return false;
  const toMinutes = (value) => {
    const match = String(value || '').match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return null;
    return Number(match[1]) * 60 + Number(match[2]);
  };
  const leftStart = toMinutes(left.fromTime);
  const leftEnd = toMinutes(left.toTime);
  const rightStart = toMinutes(right.fromTime);
  const rightEnd = toMinutes(right.toTime);
  if (leftStart == null || leftEnd == null || rightStart == null || rightEnd == null) return true;
  return !(leftEnd <= rightStart || rightEnd <= leftStart);
}
